export enum BulkReportType {
  Summary = "summary",
  Breakdown = "breakdown",
  CategoryCoreNutrient = "categoryCoreNutrient",
  PrintCategory = "printCategory",
}

export enum DishBulkReportType {
  Export = "export",
  CategoryCoreNutrient = "categoryCoreNutrient",
}

export type ReportCategoryScopeMode = "all" | "selected";

export interface GenerateReportOption {
  value: string;
  name: string;
  description?: string;
}

export interface GenerateReportCategoryOption {
  value: number;
  name: string;
  description?: string;
}

export interface GenerateReportPayload {
  reportType: string;
  country: string;
  categoryScopeMode: ReportCategoryScopeMode;
  selectedCategoryIds: number[];
}
